import React from 'react';
import classNames from 'classnames';
import type { ClassValue } from 'classnames/types';

export type SectionProps = {
  children: React.ReactNode;
  title?: string;
  className?: ClassValue;
  'data-testid'?: string;
};

const Section = ({ children, title, className, 'data-testid': dataTestId }: SectionProps): JSX.Element => (
  <section className={classNames('margin-top-4', 'margin-bottom-5', className)} data-testid={dataTestId}>
    {title ? <h2>{title}</h2> : null}
    {children}
  </section>
);

export default Section;
